import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';

import { User } from '../app/models/user.model';

import { Authentication } from './authentication'

/*
  Generated class for the MystopiaUsers provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class MystopiaUsers {
  apiBaseUrl = 'https://morning-fortress-66380.herokuapp.com';

  constructor(public http: Http, private authService: Authentication) {
    console.log('Hello MystopiaUsers Provider');
  }

  getUsers() : Observable<User[]> {
    let url = `${this.apiBaseUrl}/api/mystopians/`;
    let options = new RequestOptions({ headers: this.getHeaders() });
    return this.http.get(url, options)
      .map((res: Response) => <User[]>(res.json()));
  }

  getUserDetails(userId: string): Observable<User> {
    let url = `${this.apiBaseUrl}/api/mystopians/${userId}/`;
    let options = new RequestOptions({ headers: this.getHeaders() });
    return this.http.get(url, options)
      .map(res => {
        let jsonData = res.json();
        console.log(jsonData.data);
        return <User>(res.json());
      })
  }

  getHeaders() {
    let authHeaders = { 'Authorization': `JWT ${this.authService.getToken()}` };
    let headers = {};
    let additionalHeaders = [ authHeaders ];
    additionalHeaders.forEach((header) => {
      headers = Object.assign(headers, header);
    });
    return new Headers(headers);
  }

  searchUsers(searchParam: string): Observable<User[]> {
    return this.getUsers()
      .map(
        (users: User[]) => {
          let filteredUsers = users.filter(user => {
            let tests = [
              user.firstName.toLowerCase().startsWith(searchParam.toLowerCase()),
              user.lastName.toLowerCase().startsWith(searchParam.toLowerCase()),
              user.email.toLowerCase().indexOf(searchParam.toLowerCase()) !== -1,
            ];

            return tests.some(value => value ? true : false);
          })
          return filteredUsers;
        }
      );
  }

}



// WEBPACK FOOTER //
// ./src/providers/mystopia-users.ts